import { c as _c } from "react/compiler-runtime";
import { cn } from '@repo/ui';
import { TokenIcon, type TokenIconProps, type TokenIconSource } from './TokenIcon';
interface TokenPairProps {
  loanToken: TokenIconSource;
  collateralToken: TokenIconSource;
  size?: TokenIconProps['size'];
  variant: 'overlapping' | 'inline';
  className?: string;
  showSymbols?: boolean;
  /** Which token leads; `loan-first` matches the `LOAN / COLLATERAL` reading used across apps. */
  order?: 'loan-first' | 'collateral-first';
}
export function TokenPair(t0) {
  const $ = _c(47);
  const {
    loanToken,
    collateralToken,
    size: t1,
    variant,
    showSymbols: t2,
    className,
    order: t3
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const showSymbols = t2 === undefined ? true : t2;
  const order = t3 === undefined ? "loan-first" : t3;
  let t4;
  if ($[0] !== collateralToken || $[1] !== loanToken || $[2] !== order) {
    t4 = order === "loan-first" ? [loanToken, collateralToken] : [collateralToken, loanToken];
    $[0] = collateralToken;
    $[1] = loanToken;
    $[2] = order;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [first, second] = t4;
  if (variant === "overlapping") {
    let t5;
    if ($[4] !== className) {
      t5 = cn("flex -space-x-2", className);
      $[4] = className;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== first.address || $[7] !== first.logoUrl || $[8] !== first.symbol || $[9] !== size) {
      t6 = <TokenIcon address={first.address} symbol={first.symbol} logoUrl={first.logoUrl} size={size} className="border-2 border-transparent" />;
      $[6] = first.address;
      $[7] = first.logoUrl;
      $[8] = first.symbol;
      $[9] = size;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== second.address || $[12] !== second.logoUrl || $[13] !== second.symbol || $[14] !== size) {
      t7 = <TokenIcon address={second.address} symbol={second.symbol} logoUrl={second.logoUrl} size={size} className="border-2 border-transparent" />;
      $[11] = second.address;
      $[12] = second.logoUrl;
      $[13] = second.symbol;
      $[14] = size;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
      t8 = <div className={t5}>{t6}{t7}</div>;
      $[16] = t5;
      $[17] = t6;
      $[18] = t7;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    return t8;
  }
  let t5;
  if ($[20] !== className) {
    t5 = cn("flex items-center gap-2", className);
    $[20] = className;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== first.address || $[23] !== first.logoUrl || $[24] !== first.symbol || $[25] !== size) {
    t6 = <TokenIcon address={first.address} symbol={first.symbol} logoUrl={first.logoUrl} size={size} />;
    $[22] = first.address;
    $[23] = first.logoUrl;
    $[24] = first.symbol;
    $[25] = size;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== first.symbol || $[28] !== showSymbols) {
    t7 = showSymbols && <span className="text-xs">{first.symbol}</span>;
    $[27] = first.symbol;
    $[28] = showSymbols;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== showSymbols) {
    t8 = showSymbols && <span className="text-muted-foreground text-xs">/</span>;
    $[30] = showSymbols;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== second.address || $[33] !== second.logoUrl || $[34] !== second.symbol || $[35] !== size) {
    t9 = <TokenIcon address={second.address} symbol={second.symbol} logoUrl={second.logoUrl} size={size} />;
    $[32] = second.address;
    $[33] = second.logoUrl;
    $[34] = second.symbol;
    $[35] = size;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  let t10;
  if ($[37] !== second.symbol || $[38] !== showSymbols) {
    t10 = showSymbols && <span className="text-xs">{second.symbol}</span>;
    $[37] = second.symbol;
    $[38] = showSymbols;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] !== t10 || $[41] !== t5 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9) {
    t11 = <div className={t5}>{t6}{t7}{t8}{t9}{t10}</div>;
    $[40] = t10;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
    $[46] = t11;
  } else {
    t11 = $[46];
  }
  return t11;
}